import { FormInstance } from 'antd';
import React, { FC, useState } from 'react';
import { UseMutateFunction } from 'react-query';
import { Widget, WidgetType } from 'api/dashboard/widget';
import { toastService } from 'components/molecules/toast';
import {
  FilterableField,
  GroupedOptions,
} from 'components/organisms/tasks/fields';
import { GroupedFilter } from 'components/organisms/tasks/grouped-filter-popover';
import { ApiFilterTransformer } from 'components/pages/api-filter-transformer';
import { useTranslate } from 'hooks/use-translation';
import { queryClient } from 'queries';
import { EditWidgetMutationPayload, getQueryWidgetKey } from 'queries/widgets';
import { FormValues, StepTwo } from './step-two';

interface EditWidgetProps {
  widget: Widget;
  transformer: ApiFilterTransformer<GroupedFilter>;
  fields: GroupedOptions<FilterableField>[];
  form: FormInstance<FormValues>;
  closeDrawer: () => void;
  editWidget: UseMutateFunction<
    Widget,
    unknown,
    EditWidgetMutationPayload,
    unknown
  >;
}

export const EditDefaultWidget: FC<EditWidgetProps> = ({
  widget,
  fields,
  transformer,
  form,
  closeDrawer,
  editWidget,
}) => {
  const [filter, setFilter] = useState<GroupedFilter>(
    transformer.from(widget.simpleSearchFilter),
  );

  const translate = useTranslate();
  const updateWidget = (values: FormValues) => {
    if (widget) {
      editWidget(
        {
          widgetId: widget.widgetId,
          simpleSearchFilter: transformer.to(filter),
          ...values,
        },
        {
          onSuccess: async (res) => {
            await queryClient.invalidateQueries(
              getQueryWidgetKey(widget.widgetId),
            );
            await queryClient.refetchQueries({
              predicate: (query) =>
                query.queryKey[0] === 'resolve-multiple' &&
                query.queryKey[1] === widget.widgetId,
            });
            const card = translate('dashboard.card');
            const chart = translate('dashbaord.chart');
            const message = translate(
              'dashboard.widget.update.success.message',
              {
                widgetName: res.widgetName,
                widgetType: [
                  WidgetType.CustomCard,
                  WidgetType.ProjectCount,
                  WidgetType.ARR,
                ].includes(res.widgetType)
                  ? card
                  : chart,
              },
            );

            const title = translate('success');

            toastService({
              title,
              message,
            }).success();
            closeDrawer();
          },
        },
      );
    }
  };

  return (
    <StepTwo
      form={form}
      fields={fields}
      filter={filter}
      setFilter={setFilter}
      onFinish={updateWidget}
      initialValues={{ widgetName: widget.widgetName }}
    />
  );
};
